import React from "react";

export const Checkbox = ({
    key,
    id,
    name,
    number,
    label,
    radio = false,
    singleOptions,
    mustBeSingle = false,
    componentName,
    answersOnQuestions,
    setAnswersOnQuestions,
                             radioOptions
}) => {
    const changeHandler = (e) => {
        let target = e.target,
            id = target.id

        setAnswersOnQuestions((answersOnQuestionsOld) => {
            const answersOnQuestionsDraft = {...answersOnQuestionsOld},
                componentCheckbox = answersOnQuestionsDraft[componentName]

            if (Array.isArray(componentCheckbox) && componentCheckbox.includes(id)) {
                const indexForRemove = componentCheckbox.indexOf(target.id)

                answersOnQuestionsDraft[componentName].splice(indexForRemove, 1)


            } else {
                answersOnQuestionsDraft[componentName] = Array.isArray(componentCheckbox) ? [...componentCheckbox, id] : [id]

                if (singleOptions && Array.isArray(componentCheckbox) && componentCheckbox.length > 0) {


                    singleOptions.forEach((item) => {
                        const singleItemIndex = answersOnQuestionsDraft[componentName].indexOf(item.id)

                        if (singleItemIndex != -1) {
                            answersOnQuestionsDraft[componentName].splice(singleItemIndex, 1)
                        }

                    })

                }

                if (radioOptions && radio && Array.isArray(componentCheckbox) && componentCheckbox.length > 0) {
                    const radioToRemove = radioOptions.map(item => {
                        if (item.id !== id)
                            return item.id;
                    });

                    answersOnQuestionsDraft[componentName] =
                        answersOnQuestionsDraft[componentName].filter(answer => !radioToRemove.includes(answer))
                }

                if (mustBeSingle === true) {
                    answersOnQuestionsDraft[componentName] = [id]
                }



            }


            localStorage.setItem(`${componentName}IsArray`, 'true');
            localStorage.setItem(componentName, answersOnQuestionsDraft[componentName])

            return answersOnQuestionsDraft
        })
    },
        isChecked = Array.isArray(answersOnQuestions[componentName]) && answersOnQuestions[componentName].includes(id)

    return (
        <div className="choice__act" key={key}>
            <input id={id}
                   type={'checkbox'}
                   name={name}
                   checked={isChecked}
                   onChange={changeHandler}
            />
            <label id={id}>
                {number ? (<span>{number}</span>) : (<div className={'choice__check'}/>)}
                {label}
            </label>
        </div>
    )

}